import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';
import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';

import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { prepareForm } from './../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


const ExpenseVatEdit = () => {

    let navigate = useNavigate();
    const {  expenseVatStore }= useStores();
    const { getById, expenseVat, save, reset } = expenseVatStore;
    const { t, i18n } = useTranslation();
    
    const { id } = useParams();
    const isNew = () => id && id == "new";

    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    

    useEffect(() => {
        async function fetchMyAPI() {
            setIsLoading(true);
            getById(id).then(() => {
                setIsLoading(false);

            });
        }

        if (id == "new") {
            handleReset();
        } else {
            fetchMyAPI();
        }

    }, [getById, reset]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id","tax"]);               
            save(formData, () => {goToList() });
        }

        setValidated(true);
    };

    const handleReset = () => {
        reset();
        setValidated(false);
    };

    const goToList = () => {
        navigate("/administration/expensevats")
    };

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Card>
                <Card.Body>                                    
                        <Stack direction="vertical">
                        <Row>
                            <Col style={{ alignSelf: "center" }}  >
                                <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../expensevats")} size="small" />

                                <b>{t(isNew() ? 'newExpenseVat' : 'expenseVat')} {!isNew() && `(Id: ${id})`}</b>
                            </Col>
                            <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>

                            <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                            </Row>

                            <hr />

                        <Row className="my-2">
                            <Col xs={2}>
                                <FormText hidden isNumber id="id" type="number" object={expenseVat} />                                
                                <FormText useFormattedInput allowDefault decimalScale={2} type="number" step=".01" required label={t("tax")} id="tax" isLoading={isLoading} object={expenseVat} valueIfNull={"0"} />
                            </Col>
                            
                            <Col xs={2}>
                                <FormText required label={t("winbizCode")} id="winbizCode" isLoading={isLoading} object={expenseVat} />
                            </Col>
                            
                            
                        </Row>
                        <Row className="my-2">
                            <Col xs={2}>
                                <FormSwitch title={""}label={t("archived")} id="archived" isLoading={isLoading} object={expenseVat} /*observe={(v) => setSalary(v)}*/ />
                            </Col>
                        </Row>

                        </Stack>

                    

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(ExpenseVatEdit);
